import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { useParams, useHistory } from "react-router-dom";
import * as R from "ramda";

import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";

import DashboardContext from "../context/DashboardContext";
import Button from "../components/Button";
import AnsweresRow from "../components/AnsweresRow";
import * as Typography from "../components/Typography";
import { getProtocolStatus } from "../utils/functional";
import { BASE_URL } from "../constants/constants";

const DashboardProtocol = (props) => {
  const params = useParams();
  const history = useHistory();
  const { userEmail = "" } = useContext(DashboardContext);
  const protocolId = props.protocolId || params.protocolId;
  const [reply, setReply] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [protocolData, setProtocolData] = useState({});

  const navigateBackToHome = () => history.push(`/dashboard`);
  const {
    id,
    answers = [],
    title = "",
    description = "",
    unity = "",
    classification = "",
    email = "",
    name = "",
    bonding = "",
    phone = "",
    file = {},
  } = protocolData;

  useEffect(() => {
    const body = { id: protocolId };
    const options = buildOptions("POST", body);
    fetchData();

    async function fetchData() {
      try {
        const response = await fetch(`${BASE_URL}/getProtocolById`, options);

        if (response.status === 500) {
          setProtocolData({});
        }

        const data = await response.json();
        setProtocolData(data);
      } catch (err) {
        setProtocolData({});
        console.log(err);
      }
    }
  }, [protocolId, refreshData]);

  const getAuthor = R.pipe(R.split("@"), R.head, R.toUpper);

  const handleReply = async () => {
    setIsloading(true);
    const timestamp = Date.now().toString();

    const author = getAuthor(userEmail);
    const body = { id, description: reply, timestamp, author };
    const options = buildOptions("POST", body);
    try {
      await fetch(`${BASE_URL}/postAnswer`, options);
    } catch (err) {
      console.log(err);
    } finally {
      setReply("");
      setIsloading(false);
      setRefreshData((refresh) => !refresh);
    }
  };

  const rows = [
    { title: "Status", value: getProtocolStatus(answers) },
    { title: "Titulo", value: title },
    { title: "Nome", value: name },
    { title: "Vinculo", value: bonding },
    { title: "E-mail", value: email },
    {
      title: "Telefone",
      value: phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3"),
    },
    { title: "Classificação", value: classification },
    { title: "Unidade", value: unity },
    { title: "Descrição", value: description },
  ];

  if (file.url)
    rows.push({
      title: "Anexo",
      value: (
        <a href={file.url} target="_blank" rel="noopener noreferrer">
          {file.name}
        </a>
      ),
    });

  return (
    <Container>
      <Link
        style={{ display: "flex", cursor: "pointer" }}
        color="inherit"
        onClick={navigateBackToHome}
      >
        <HomeIcon style={{ marginRight: "15px", width: "20px" }} />
        <span style={{ marginTop: "2px" }}>Retornar</span>
      </Link>
      <Separator />
      <Separator />

      <table>
        <tbody style={{ display: "flex", flexDirection: "column" }}>
          {rows
            .filter(({ value }) => !!value)
            .map(({ title, value }) => (
              <tr
                key={title}
                style={{
                  marginBottom: "20px",
                }}
              >
                <td style={{ width: "140px" }}>
                  <Typography.span weight={600}>{title}</Typography.span>
                </td>
                <td>
                  <Typography.span>{value}</Typography.span>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <Separator />
      {!!answers.length && (
        <div>
          <Backdrop>
            <Header>Histórico</Header>
          </Backdrop>
          <Separator />
          {answers.map((answer) => (
            <AnsweresRow {...answer} />
          ))}
        </div>
      )}
      <Separator />
      <Backdrop>
        <Header>Responder</Header>
      </Backdrop>
      <Separator />

      <TextareaAutosize
        placeholder="inserir nova resposta"
        rowsMin={10}
        value={reply}
        onChange={(e) => setReply(e.target.value)}
      />
      <Separator />
      <ButtonContainer>
        <Button
          variant="contained"
          color="primary"
          disabled={isLoading || !reply.length}
          onClick={() => handleReply()}
        >
          Responder
        </Button>
      </ButtonContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  padding: 40px 60px;
`;

const Header = styled(Typography.h2)`
  && {
    color: #fff;
    margin: 5px;
  }
`;

const Backdrop = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  background-color: #0d4f78;
  flex: 1;
`;

const Separator = styled.div`
  margin: 10px 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const buildOptions = (method, body) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  if (body) return { method, headers, body: JSON.stringify(body) };

  return { method };
};
export default DashboardProtocol;
